import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import noop from 'lodash/noop';

import {
  ChevronLeftIcon,
  ChevronRightIcon,
  FullscreenIcon
} from 'zoomforth_component_lib/external_modern_icons.jsx';

import PresentationProgressBar from './presentation.progress_bar.jsx';

const PresentationBottomBar = ({
  slides,
  currentSlideIdx,
  totalSlides,
  onNextClick,
  onPrevClick,
  onGoToSlideClick,
  onFullscreenClick
}) => {

  const currentSlideNum = currentSlideIdx + 1;
  const isFirstSlide = currentSlideIdx === 0;
  const isLastSlide = currentSlideIdx === (totalSlides - 1);

  return (
    <div className="presentation-bottom-bar">

      <div className="presentation-left">
        <ChevronLeftIcon
          className={classNames('prev-btn', { disabled: isFirstSlide })}
          onClick={isFirstSlide ? noop : onPrevClick}
        />

        <div className="slide-counter">
          { currentSlideNum } of { totalSlides }
        </div>

        <ChevronRightIcon
          className={classNames('next-btn', { disabled: isLastSlide })}
          onClick={isLastSlide ? noop : onNextClick}
        />
      </div>

      <div className="presentation-right">
        <PresentationProgressBar
          slides={slides}
          totalSlides={totalSlides}
          currentSlideIdx={currentSlideIdx}
          onGoToSlideClick={onGoToSlideClick}
        />

        <FullscreenIcon
          className="fullscreen-btn"
          onClick={onFullscreenClick}
        />
      </div>

    </div>
  );
};

PresentationBottomBar.propTypes = {
  slides: PropTypes.array.isRequired,
  currentSlideIdx: PropTypes.number.isRequired,
  totalSlides: PropTypes.number.isRequired,
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired,
  onGoToSlideClick: PropTypes.func.isRequired,
  onFullscreenClick: PropTypes.func.isRequired
};

export default PresentationBottomBar;
